import { ws } from "../../../utils/common";

export const postAnswerOfQuestion = async ({ id_user_question, answer }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "answer-question/" + id_user_question,
    null,
    { answer },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
